import { components, OptionProps } from 'react-select';
import SVG from 'react-inlinesvg';
import locationSvg from 'assets/icons/location.svg';
import frameSvg from 'assets/icons/frame.svg';
import { CombinedSearchResult } from '../SearchBar.types';

export const CustomOption = (props: OptionProps<CombinedSearchResult>): React.ReactElement => {
  const { data, children, ...optionProps } = props;
  const iconSrc = data.type === 'location' ? locationSvg : frameSvg;

  return (
    <components.Option
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(optionProps as OptionProps)}
    >
      <div className="flex items-center">
        <SVG className="text-primary mr-2 flex-shrink-0" src={iconSrc} />
        {children}
      </div>
    </components.Option>
  );
};
